<template lang="pug">
div
	.form-group
		label
			b Etiquetas
		input.form-control(placeholder="Escribe una etiqueta y pulsa intro", v-model="nueva", @keypress.enter="crear", v-if="!readonly")
	hr(v-if="!readonly")
	button.btn.btn-sm.btn-warning.m-1(
		v-for="etiqueta in texto.Etiquetas"
		:key="etiqueta.Etiqueta"
		@click="quitar(etiqueta.Etiqueta)"
	) {{etiqueta.Etiqueta}}
</template>

<script>
import axios from 'axios'
export default {
	props: ['texto', 'readonly'],
	data () {
		return {
			nueva: ''
		}
	},
	methods: {
		crear () {
			if (this.nueva) {
				const form = {
					NoticiaID: this.texto.NoticiaID,
					Etiqueta: this.nueva
				}
				axios.post('redaccion/php/api/add-etiqueta.php', form)
					.then(res => {
						this.texto.Etiquetas = res.data
						this.nueva = ''
					})
					.catch(this.$responseError)
			}
		},
		quitar (Etiqueta) {
			if (this.readonly) {
				return
			}
			const form = {
				NoticiaID: this.texto.NoticiaID,
				Etiqueta: Etiqueta
			}

			axios.post('redaccion/php/api/del-etiqueta.php', form)
				.then(res => {
					this.texto.Etiquetas = res.data
				})
				.catch(this.$responseError)
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/redaccion/vue/componentes/editor/etiquetas.vue